import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import type { AccountsInfoResponseDto } from './types';
import { type BaseAsset } from '@/shared/types/assetsTypes';
import type {
  AccountsRestsBaseResponseDto,
  AccountsMarginRestsBaseResponseDto,
} from '../model';

export const getAccountsInfo = async () => {
  const request = () => apiClient.get('/accounts/info');
  const response = await handleRequest<AccountsInfoResponseDto>(request);
  return response.data;
};

export const getAccountsRestsInBaseAsset = async (
  acc: string,
  baseAsset: BaseAsset
) => {
  const request = () =>
    apiClient.get(`/accounts/${acc}/rests/base/${baseAsset}`);
  const response = await handleRequest<AccountsRestsBaseResponseDto>(request);
  return response.data;
};

export const getExtendedMarginAccountsRestInBaseAsset = async (
  baseAsset: BaseAsset
) => {
  const request = () =>
    apiClient.get(`/accounts/rests/margin/extended/base/${baseAsset}`);
  const response =
    await handleRequest<AccountsMarginRestsBaseResponseDto>(request);
  return response.data;
};
